import React, { useEffect } from 'react';
import { List, Datagrid, FunctionField } from 'react-admin';
import VideoFileIcon from '@mui/icons-material/VideoFile';

function QuienesSomosList(props: any) {
  useEffect(() => {
    document.title = 'Quiénes Somos - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <FunctionField
          label="Descripción"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || "Sin contenido";
            return <span>{text.substring(0, 50)}...</span>;
          }}
        />
        <FunctionField
          label="Video/Archivo"
          render={(record: any) => record.videoUrl ? <VideoFileIcon color="primary" /> : 'No hay archivo'}
        />
      </Datagrid>
    </List>
  );
}

export default QuienesSomosList;